import { postApi } from "../apiCall";

export const getSearchListCurrent = (token, user) => {
  let url = `${process.env.REACT_APP_API_URL}/${user}/capacity/getAll`;
  return postApi(url);
};
